// extracted by mini-css-extract-plugin
export default {"infoBlock":"buyers_infoBlock__n4zty","itemsListContent":"buyers_itemsListContent__9sizA","infoBlockTitle":"buyers_infoBlockTitle__yZ5Br","buttonsBlock":"buyers_buttonsBlock__TfrtN"};